<template>
  <div class='step4'>
    <a-form-model ref='form' :model='model' :rules='validatorRules' :labelCol='labelCol' :wrapperCol='wrapperCol'>
      <a-form-model-item  :label='item.name' v-for="(item,index) in model.itemList" :key="index">
        <a-radio-group v-model='item.periodRule' :options='radios' />

        <a-select v-model='item.periodItemId' placeholder='请选择周期' v-if="item.periodRule==='4'">
          <a-select-option :value='pitem.id' :key="pitem.id" v-for="pitem in periodItemList">{{pitem.name}}</a-select-option>
        </a-select>
        
      </a-form-model-item>
      
    </a-form-model>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
export default {
  data() {
    return {
      labelCol: {
        span: 8
      },
      wrapperCol: {
        span: 16
      },
      // radios:[{ label: '基线周期', value: '1' },{ label: '相同周期', value: '2' }, { label: '上一周期', value: '3' },{ label: '指定周期', value: '4' }],
      radios:[{ label: '相同周期', value: '2' }],
      model:{},
      validatorRules: {},
      periodItemList:[]
    }
  },
  created(){
  },
  methods: {
    view(model){
      model.itemList.forEach(item=>{
        item.periodRule = item.periodRule||'2'
      })
      this.model = JSON.parse(JSON.stringify(model))
      // this.periodRuleChange()
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          if(this.model.itemList){
            this.model.itemList.forEach(item=>{
              item.name = item.name.replace(".基线周期】","】")
              item.name = item.name.replace(".相同周期】","】")
              item.name= item.name.replace(".上一周期】","】")
              if(item.name.indexOf(".指定周期")>-1){
                item.name = item.name.replace(item.name.substring(item.name.indexOf('.指定周期'),item.name.length-1),'')
              }
              if(!(item.name.endsWith(`.基线周期】`)||item.name.endsWith(`.相同周期】`)||item.name.endsWith(`.上一周期】`) || item.name.indexOf(".指定周期")>-1)){
                item.name = this.insertStr(item.name,item.name.length-1,`.${this.getRadioText(item.periodRule,item.periodItemId)}`)
              }
            })
          }
          result = true
        }
      })
      return result
    },
    insertStr(source, start, newStr) {
      return source.slice(0, start) + newStr + source.slice(start)
    },
    getRadioText(value,periodItemId){
      let name = ''
      this.radios.forEach(item=>{
        if(item.value===value){
          name = item.label
        }
      })
      if(value==='4'){
        this.periodItemList.forEach(pItem=>{
          if(pItem.id===periodItemId){
            name = name + '.' + pItem.name
          }
        })
      }
      return name
    },
    periodRuleChange(){
      if(this.periodItemList.length===0){
        getAction('/project/projectPeriodItem/list',{projectId:this.model.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
      }
    },
  }
}
</script>

<style scoped>

</style>
